import React from 'react';
import { CircularProgress } from '@mui/material';
import style from './LoadingContent.module.scss';
import propTypes from 'prop-types';

export default function LoadingContent({ message = 'Loading...' }) {
  return (
    <div className={style.loadingContent}>
      <CircularProgress size={30} />
      <span>{message}</span>
    </div>
  );
}

LoadingContent.propTypes = {
  message: propTypes.string
};
